/**
 *
 * Search Input: Do not change the style
 *
 */

import FormControl from '@material-ui/core/FormControl'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

import Icon from '../Icon'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
    '& *:focus': {
      outline: 'unset',
    },
  },
  wrapper: {
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '4px',
    padding: '6px 10px 6px 30px',
    width: '100%',
    '&:focus-within': {
      backgroundColor: theme.inputField.inputBGColorActive,
      borderColor: theme.inputField.inputBorderActive,
    },
  },
  inputstyle: {
    // width: '90%',
    width: 'calc(100% - 20px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '0.875rem',
  },
  iconLeft: {
    position: 'absolute',
    top: 9,
    left: 9,
  },
})

/* eslint-disable react/prefer-stateless-function */
class SearchInput extends React.Component {
  render() {
    const { classes, ContainterStyle, ...rest } = this.props
    return (
      <FormControl style={ContainterStyle} className={classes.root}>
        <div className={classes.wrapper}>
          <Icon iconSize={18} iconName="search" color="grey" className={classes.iconLeft} />
          <input {...rest} className={classes.inputstyle} placeholder="Search" />
        </div>
      </FormControl>
    )
  }
}

SearchInput.defaultProps = {}
export default withStyles(styles)(SearchInput)
